var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user)?_c('div',[_c('h1',[_vm._v("TODO: Users page ...")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }